var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83242 12.167C9.83242 11.7073 9.45984 11.3347 9.00017 11.3347C8.54059 11.3347 8.16801 11.7073 8.16801 12.167C8.16801 12.6266 8.54059 12.9992 9.00017 12.9992C9.45984 12.9992 9.83242 12.6266 9.83242 12.167ZM9.61642 5.62258C9.57476 5.31754 9.31309 5.08263 8.99667 5.08288C8.65151 5.08315 8.37192 5.3632 8.37217 5.70838L8.37517 9.45974L8.38092 9.54449C8.42259 9.84958 8.68426 10.0845 9.00067 10.0842C9.34584 10.0839 9.62542 9.80391 9.62517 9.45874L9.62217 5.70738L9.61642 5.62258ZM10.6408 1.04939C9.92717 -0.240439 8.07284 -0.240422 7.35934 1.04944L0.904956 12.7173C0.213656 13.967 1.11751 15.4999 2.54566 15.4999L15.4548 15.4999C16.883 15.4999 17.7868 13.967 17.0955 12.7172L10.6408 1.04939ZM8.45317 1.6545C8.69101 1.22455 9.30909 1.22454 9.54692 1.65449L16.0018 13.3224C16.2322 13.7389 15.9309 14.2499 15.4548 14.2499L2.54566 14.2499C2.06961 14.2499 1.76832 13.7389 1.99876 13.3224L8.45317 1.6545Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/delete_account.76c28dc2c236e36a4387f496c15555d3.svg";
export { ForwardRef as ReactComponent };